import styled from 'styled-components';

export const Wrap = styled.div`
  && {
    .section {
      margin-bottom: 65px;
    }
    .btn-change-bill-detail {
      background-color: #ff8a00;
      color: white;
      border: none;
      border-radius: 5px;
    }
    .content-xlsx {
      padding: 24px;
    }
    .name-xlsx {
      padding: 4px 0 0 16px;
    }
    .btn-xlsx {
      display: flex;
    }
    .btn-output-pdf {
      margin-left: 10px;
      background-color: #a956ea;
      color: white;
      border: none;
      border-radius: 5px;
    }
    .logic {
      background-color: rgba(236, 255, 184, 1);
      height: 95px;
    }
    .header-choose {
      background-color: rgba(236, 255, 184, 1);
      padding-top: 20px;
      padding-left: 60px;
      display: flex;
      align-items: center;
      padding-bottom: 30px;
    }
    .table {
      margin-top: 5px;
    }
    .ant-tabs {
      margin-left: 40px;
      margin-top: 7px;
    }
    .ant-tabs-tab {
      background-color: rgba(236, 255, 184, 1);
      width: 170px;
      height: 56px;
      border-top-left-radius: 15px !important;
      border-top-right-radius: 15px !important;
      margin-right: 10px;
      color: black;
      font-family: Hiragino Kaku Gothic Pro;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: black;
    }
    .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active,
    .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab-active {
      background-color: white;
      transition: 1s;
    }

    .ant-tabs-top > .ant-tabs-nav::before,
    .ant-tabs-bottom > .ant-tabs-nav::before,
    .ant-tabs-top > div > .ant-tabs-nav::before,
    .ant-tabs-bottom > div > .ant-tabs-nav::before {
      border-bottom: none !important;
    }
    .invoice {
      margin-top: 25px;
      margin-bottom: 90px;
      box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      .bill {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border: 1px solid #dddddd;
        border-top: none;
      }
      .title {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border: 1px solid #dddddd;
      }
      .mgrl-25 {
        margin: 0px 25px;
      }
      .mgt-13 {
        margin-top: 13px;
      }
      .mgt-30 {
        margin-top: 30px;
      }
      .dl {
        display: flex;
        justify-content: space-between;
        padding-top: 30px;
      }
      .w-card {
        width: 196px;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
      }
      .money-info {
        padding: 24px;
        background-color: white;
        text-align: center;
        font-family: Hiragino Kaku Gothic Pro;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
      }
      .w-bg {
        background-color: #c1e18d;
      }
      .w-bg-ec {
        background-color: #ecffb8;
      }
      .w-gb-gr {
        background-color: #f6f6f6;
      }
      .pay {
        margin: 0px 25px;
        margin-bottom: 30px;
        .wrap-bill:first-child {
          margin: 0px 157px;
          padding-top: 42px;
        }
        .wrap-bill {
          margin: 0px 157px;
        }
        .bd-style {
          border-bottom: 1px dashed black;
          border-left: none;
          border-right: none;
          border-top: none;
        }
        .bd-solid {
          border-bottom: 1px solid black;
        }
        .bd-solid-2 {
          border-bottom: 2px solid black;
        }
        .detail-bill {
          width: 100%;
          padding-top: 15px;
        }
        .txt-area {
          height: 111px;
        }
      }
      .pd-7 {
        padding-bottom: 7px;
      }
      .t-al {
        text-align: right;
      }
      .pd-15 {
        padding-bottom: 15px;
      }
    }
    .ant-col-4 {
      max-width: 20%;
    }
    .ant-card-head {
      height: 30px !important;
      min-height: 0px;
      text-align: center;
      border-bottom: none;
    }
    .ant-card-head-title {
      padding: 10px 0px;
      font-family: Hiragino Kaku Gothic Pro;
      font-size: 12px;
      font-style: normal;
      color: #777777;
      font-weight: 700;
    }
    .ant-card-body {
      padding: 10px 10px;
    }
    .tb-height {
      height: 51px;
    }
    .col-fl {
      display: flex;
      align-items: center;
      border: 1px solid black;
      padding-left: 10px;
    }
    .col-fl:first-child {
      border-right: none;
    }
    .col-fl-2 {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid black;
    }
    .bd-bt {
      border-bottom: none;
    }
    .pdt-60 {
      padding-top: 60px;
    }
  }
`;
